export default "__VITE_ASSET__CN334Qnc__"